import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import en from "date-fns/locale/en-US";
import ru from "date-fns/locale/ru";
import hy from "date-fns/locale/hy";

registerLocale("en", en);
registerLocale("ru", ru);
registerLocale("hy", hy);

import ruTrans from "./ru.json";
import enTrans from "./en.json";
import armTrans from "./hy.json";

const detectOptions = {
    order: [
        "querystring",
        "cookie",
        "localStorage",
        "sessionStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
    ],
    lookupCookie: "locale",
    caches: ["cookie"],
};

i18n.use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        detection: detectOptions,
        debug: true,
        fallbackLng: "en",
        supportedLngs: ["en", "ru", "hy"],
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            en: {
                translation: enTrans,
            },
            ru: {
                translation: ruTrans,
            },
            hy: {
                translation: armTrans,
            },
        },
    });

export default i18n;
